import React from 'react';
import { QueryReportTitleReact } from 'common/query-builder/query-report-title';
import { QueryReportHeaderSave } from 'common/query-builder/query-report-header/types';
import { SearchDisplayContext } from 'common/report/util/search/types';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { isTestEnv } from 'common/report/util/env';
import { ReportBannersReact } from 'common/widgets/report-banners';
import { PageTrackingEvent, trackExperimentPageAction, TrackingEventSource } from 'apps/experiments/src/components/tracking';
import { useUpdateExperiment } from 'iron/apps/experiments/src/components/hooks/update-experiment';
import { useUndoRedoKeyCommands } from 'common/hooks/useUndoRedoKeyCommands';
import { useExperimentHistory } from 'iron/apps/experiments/src/components/hooks/history';
import { useStagedExperiment } from 'iron/apps/experiments/src/components/hooks/staged-experiment';
import { ExperimentPageSummary } from '../summary';
import styles from './index.module.styl';
export function ExperimentPageMain() {
  var _experiment$name;
  const {
    t
  } = useTranslation();
  const {
    projectId,
    workspaceId
  } = useExperimentPageContext();
  const {
    stagedExperiment: experiment
  } = useStagedExperiment();
  const updateExperiment = useUpdateExperiment();
  const {
    undo,
    redo
  } = useExperimentHistory();
  useUndoRedoKeyCommands(undo, redo);
  const onSave = React.useCallback((saveParams: QueryReportHeaderSave) => {
    updateExperiment({
      name: saveParams.name,
      description: saveParams.description
    });
    if ((experiment === null || experiment === void 0 ? void 0 : experiment.name) !== saveParams.name) {
      trackExperimentPageAction({
        event: PageTrackingEvent.EditName,
        experiment,
        source: TrackingEventSource.ExperimentPage
      });
    }
    if (experiment !== null && experiment !== void 0 && experiment.description && experiment.description !== saveParams.description) {
      trackExperimentPageAction({
        event: PageTrackingEvent.EditDescription,
        experiment,
        source: TrackingEventSource.ExperimentPage,
        props: {
          description: saveParams.description,
          'description - length': saveParams.description.length
        }
      });
    }
  }, [experiment, updateExperiment]);
  return <div className={styles.mainWrapper} data-sentry-component="ExperimentPageMain" data-sentry-source-file="index.tsx">
      {!isTestEnv() && <ReportBannersReact />}
      <main className={styles.main}>
        <QueryReportTitleReact allowStaffOverride={false} canSave={!!(experiment !== null && experiment !== void 0 && experiment.can_update_basic)} canWrite={!!(experiment !== null && experiment !== void 0 && experiment.can_update_basic)} displayContext={SearchDisplayContext.Experiment} entityName={(_experiment$name = experiment === null || experiment === void 0 ? void 0 : experiment.name) !== null && _experiment$name !== void 0 ? _experiment$name : ""} entityDescription={(experiment === null || experiment === void 0 ? void 0 : experiment.description) || ""} emptyEntityName={t("experiments.list.new")} projectId={projectId} hasUnsavedChanges={false} invalidEntity={false} isSuperadmin={!!(experiment !== null && experiment !== void 0 && experiment.is_superadmin)} selectedEntityId={experiment!.id} trackName='[Experiment]' workspaceId={workspaceId} onSave={onSave} data-sentry-element="QueryReportTitleReact" data-sentry-source-file="index.tsx" />
        <ExperimentPageSummary data-sentry-element="ExperimentPageSummary" data-sentry-source-file="index.tsx" />
      </main>
    </div>;
}